import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BuildingCanvas } from './components/BuildingCanvas';
import { FloorNavigator } from './components/FloorNavigator';
import { Toolbar } from './components/Toolbar';
import { RoomModal } from './components/roomEditing/RoomModal';
import { theme } from './theme';
import './App.css';
import { useApp, AppProvider } from './stateMgmt/AppContext';
import { RoomCreationDialog } from 'components/RoomCreationDialog';

function AppContent() {

  const { selectedRoomId, pendingRoomPosition, setPendingRoomPosition, setSelectedRoomId } = useApp();

  console.log('current selectedRoomId:', selectedRoomId);
  
  return (
    <div className="App" style={{ height: '95vh', display: 'flex', flexDirection: 'column', margin: 'auto' }}>
      <FloorNavigator />
      <Toolbar />
      <div style={{ flex: 1, position: 'relative', overflow: 'hidden', margin: 'auto' }}>
        <BuildingCanvas/>
      </div>
      {selectedRoomId && (
        <RoomModal
          roomId={selectedRoomId}
          onClose={() => setSelectedRoomId(null)}
        />
      )}
      {pendingRoomPosition && (
        <RoomCreationDialog/>
      )}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
        <AppContent />
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
